import { createStyles } from "@app/components/tss/hooks/use-tss-styles";

export const useStyles = createStyles(({ theme }) => {
  const { styles, colors } = theme.busbud;

  return {
    resetButton: {
      background: colors.background.primary.opaque,
      boxShadow: styles.shadow.subtle.sm,
      color: colors.icon.primary.opaque
    }
  };
});
